import { useEffect } from "react";

import { useLocale } from "../primitives/useLocale";
import type { PendingCreatesSource } from "../seams";
import { queuedCopyKeys } from "./copyKeys";
import type { PendingCopiesStore } from "./pendingCopiesStore";

/** #475: hold every create the host's queue still carries, once per row.
 *  Read at mount and on every change of the queue (its read from disk
 *  lands after the boot). A row that leaves the queue delivered drops
 *  nothing: its entry leaves when the network list shows the copy, the one
 *  reconcile. A row that leaves undelivered (dropped, dismissed, refused)
 *  releases its entry at once. Mounted only by a host with a queue
 *  (mobile): web renders none. */
export function QueuedCopiesFeed({
  store,
  source,
}: {
  store: PendingCopiesStore;
  source: PendingCreatesSource;
}): null {
  const lang = useLocale();
  useEffect(() => {
    let live = new Set<string>();
    const read = () => {
      const rows = source.pending();
      const now = new Set(rows.map((row) => row.id));
      for (const id of live) if (!now.has(id) && !source.delivered(id)) store.release(id);
      live = now;
      for (const row of rows) store.hold(queuedCopyKeys(row, lang), row.id);
    };
    const off = source.subscribe(read);
    read();
    return off;
  }, [store, source, lang]);
  return null;
}
